module.exports = __webpack_public_path__ + "assets/img/1-1.7bca337e.jpg";